import BaseHandler from "./BaseHandler";
import {
  HANDLERS,
  INSTANCES
} from '../constants/globals';
import {
  dismantleAllInstancesExceptPageLoader,
  initAllInstancesExceptPageLoader
} from '../functions/utils';

export default class PageLoaderHandler extends BaseHandler {
  constructor() {
    super();
    this.header = document.querySelector('.rf-header');
    this.loader = document.querySelector('[data-is="loader"]');
    this.transitionTime = 0.8;
    this.body = document.body;
    this.page = this.getPageAttributes();
    this.initBodyTags();
    this.setActiveLinks();
  };

  init = (aos) => {
    HANDLERS["pageLoaderHandler"] = this;
    //let navHandler = INSTANCES["navMenus"]["globalSideNav"];
    let handler = this;
  };

  showHeader = () => {
    setTimeout(() => {
      this.header.classList.remove('hide');
    }, 500);
  };

  hideHeader = () => {
    this.header.classList.add('hide');
  };

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  removeBodyTag = () => {
    const prefix = "body--";
    const classes = this.body.getAttribute('class').split(" ").filter(c => !c.startsWith(prefix));
    this.body.setAttribute('class', classes.join(" "));
  };

  addBodyTag = (tag) => {
    this.body.classList.add(`body--${tag}`);
  };

  getPageAttributes = (el = document) => {
    return {
      title: el.querySelector('[data-page-title]') ? el.querySelector('[data-page-title]').getAttribute('data-page-title') : null,
      modifier: el.querySelector('[data-page-modifier]') ? el.querySelector('[data-page-modifier]').getAttribute('data-page-modifier') : null
    }
  };

  initBodyTags = () => {
    this.addBodyTag(this.page.modifier);
  };

  getNavLinks = () => {
    let links = document.querySelectorAll('[data-link-namespace]');
    let navLinks = [];

    if (links.length > 0) {
      links.forEach((link) => {
        let namespace = link.getAttribute('data-link-namespace');

        if (namespace.includes('[')) {
          namespace = JSON.parse(namespace);
        }

        let navLink = {
          el: link,
          namespace: namespace
        };

        navLinks.push(navLink);
      })
    }

    return navLinks;

    // Returns an array of objects with element + namespace
  };

  setActiveLinks = (pageEl = document) => {
    let links = document.querySelectorAll('[data-link-namespace]');

    if (links.length > 0) {
      links.forEach((link) => {
        link.classList.remove('active');

        let navLinks = this.getNavLinks();

        if (navLinks.length > 0) {
          let page = this.getPageAttributes(pageEl);

          navLinks.forEach((navLink) => {
            let active = false;

            if (navLink.namespace instanceof Array) {
              navLink.namespace.forEach((name) => {
                if (name === page.modifier) {
                  active = true;
                }
              })
            } else {
              if (navLink.namespace === page.modifier) {
                active = true;
              }
            }

            if (active) {
              navLink.el.classList.add('active');
            }
          });


        }
      })
    }

  };

  reInitModules = () => {

  }


}
